export const STATEMENTS_TARGET = 'statementsTarget';
